import i18n from 'i18n-js';
import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as bhActions from 'services/api/businessHours';
import { getErrorMessage, parsePagination } from 'utils';

const fetchCreateBHRequest = () => ({
  type: types.FETCH_CREATE_BH_REQUEST,
});

const fetchCreateBHSuccess = (payload) => ({
  type: types.FETCH_CREATE_BH_SUCCESS,
  payload,
});

const fetchCreateBHFailed = () => ({
  type: types.FETCH_CREATE_BH_FAILED,
});

export const fetchCreateBH = (payload, params) => {
  return async (dispatch) => {
    dispatch(fetchCreateBHRequest());

    const response = await bhActions.fetchCreateBH(payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('business_hours.created_successfully'),
        })
      );
      return dispatch(fetchCreateBHSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchCreateBHFailed());
  };
};

const fetchOverwriteBHRequest = () => ({
  type: types.FETCH_OVERWRITE_BH_REQUEST,
});

const fetchOverwriteBHSuccess = (payload) => ({
  type: types.FETCH_OVERWRITE_BH_SUCCESS,
  payload,
});

const fetchOverwriteBHFailed = () => ({
  type: types.FETCH_OVERWRITE_BH_FAILED,
});

export const fetchOverwriteBH = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchOverwriteBHRequest());

    const response = await bhActions.fetchOverwriteBH(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('business_hours.created_successfully'),
        })
      );
      return dispatch(fetchOverwriteBHSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchOverwriteBHFailed());
  };
};

const fetchAssociatedVehicleGroupsRequest = () => ({
  type: types.FETCH_ASSOCIATED_VEHICLE_GROUPS_REQUEST,
});

const fetchAssociatedVehicleGroupsSuccess = (payload) => ({
  type: types.FETCH_ASSOCIATED_VEHICLE_GROUPS_SUCCESS,
  payload,
});

const fetchAssociatedVehicleGroupsFailed = () => ({
  type: types.FETCH_ASSOCIATED_VEHICLE_GROUPS_FAILED,
});

export const fetchAssociatedVehicleGroups = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchAssociatedVehicleGroupsRequest());
    const response = await bhActions.fetchAssociatedVehicleGroups(id, payload);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchAssociatedVehicleGroupsSuccess({
          pagination,
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchAssociatedVehicleGroupsFailed());
  };
};

export const resetCurrentBusinessHour = () => ({
  type: types.RESET_BH,
});

export const updateCurrentBH = (payload) => ({
  type: types.UPDATE_CURRENT_BUSINESS_HOURS,
  payload,
});

export const handleDeleteBusinessHours = ({ index }) => {
  return async (dispatch, getState) => {
    const { current } = getState().businessHours;
    const _bh = current?.bh_rules.filter(
      (bh) => !bh?.start?.toString()?.startsWith(index.toString())
    );
    dispatch(updateCurrentBH({ bh_rules: _bh }));
  };
};

const fetchBusinessHoursByIdRequest = () => ({
  type: types.FETCH_BH_BY_ID_REQUEST,
});

const fetchBusinessHoursByIdSuccess = (payload) => ({
  type: types.FETCH_BH_BY_ID_SUCCESS,
  payload,
});

const fetchBusinessHoursByIdFailed = () => ({
  type: types.FETCH_BH_BY_ID_FAILED,
});

export const fetchBusinessHourById = (id) => {
  return async (dispatch) => {
    dispatch(fetchBusinessHoursByIdRequest());

    const response = await bhActions.fetchBusinessHoursById(id);

    if (response.ok) {
      return dispatch(fetchBusinessHoursByIdSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchBusinessHoursByIdFailed());
  };
};

const fetchUpdateBusinessHoursRequest = () => ({
  type: types.FETCH_UPDATE_BH_REQUEST,
});

const fetchUpdateBusinessHoursSuccess = (payload) => ({
  type: types.FETCH_UPDATE_BH_SUCCESS,
  payload,
});

const fetchUpdateBusinessHoursFailed = () => ({
  type: types.FETCH_UPDATE_BH_FAILED,
});

export const fetchUpdateBusinessHours = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateBusinessHoursRequest());

    const response = await bhActions.fetchUpdateBusinessHours(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('business_hours.updated_successfully'),
        })
      );
      return dispatch(fetchUpdateBusinessHoursSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchUpdateBusinessHoursFailed());
  };
};

const fetchBusinessHoursRequest = () => ({
  type: types.FETCH_BUSINESS_HOURS_REQUEST,
});

const fetchBusinessHoursSuccess = (payload) => ({
  type: types.FETCH_BUSINESS_HOURS_SUCCESS,
  payload,
});

const fetchBusinessHoursFailed = () => ({
  type: types.FETCH_BUSINESS_HOURS_FAILED,
});

export const fetchBusinessHours = (params) => {
  return async (dispatch) => {
    dispatch(fetchBusinessHoursRequest());
    const response = await bhActions.fetchBusinessHoursList(params);

    if (response.ok) {
      return dispatch(fetchBusinessHoursSuccess(response.data));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchBusinessHoursFailed());
  };
};
